import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

// The player under the org's route: the given org's (a paired federation's), else the selected org's.
const getPlayer = async (data) => {
  const { playerId, orgId } = data
  const url = `v1/orgs/${orgId || selectedOrgId()}/players/${playerId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getPlayer
